import * as datGui from 'dat.gui'
import { TrillionBackend } from '../../../../../trillion-common/src/API/trillion-backend'
import * as THREE from 'three'
import { ReflectionMapDto } from '../../../../../trillion-common/src/dto/reflection-map.dto'
import { StoreScheme } from '../../../shared/store/store'

function handleEnvironmentChange(
  name: string,
  response: ReflectionMapDto[],
  setReflectionMap: (reflectionMap: ReflectionMapDto) => void,
) {
  const selectedEnvironmentName = name
  const selectedEnvironmentData = response.find((env) => env.name === selectedEnvironmentName)

  if (selectedEnvironmentData) {
    setReflectionMap(selectedEnvironmentData)
  }
}

function loadFile(store: StoreScheme) {
  const input = document.createElement('input')
  input.type = 'file'
  input.accept = '.hdr'

  input.addEventListener('change', (event) => {
    const file: File | undefined = (event.target as HTMLInputElement)?.files?.[0]
    if (file) {
      const environmentCallback = store.getState().onEnvironmentUpload

      if (environmentCallback) {
        environmentCallback(file)
        input.remove()
      }
    }
  })

  input.click()
}

export async function addEnvironmentGUI(
  gui: datGui.GUI,
  cubemap: THREE.DataTexture | undefined,
  store: StoreScheme,
) {
  const environmentFolder = gui.addFolder('Environment')
  const setReflectionMap = store.getState().setReflectionMap

  try {
    const response: ReflectionMapDto[] | ReflectionMapDto =
      await TrillionBackend.getAllReflectionMaps()

    const responseArray = Array.isArray(response) ? response : [response]

    const guiSettings = {
      name: 'environment_new_dark.hdr',
    }

    const environmentOptions = responseArray.map(({ name }) => name as string)
    guiSettings['name'] = cubemap?.name || 'Default Environment Name'

    environmentFolder
      .add(guiSettings, 'name', environmentOptions)
      .name('Select Environment')
      .onChange((name: string) => handleEnvironmentChange(name, responseArray, setReflectionMap))

    const params = {
      name: 'environment_new_dark.hdr',
      loadFile: function () {
        loadFile(store)
      },
    }
    environmentFolder.add(params, 'loadFile').name('Upload HDR file')
  } catch (e) {
    console.error(e)
  }
}
